import React, {Component} from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'

class Text extends Component {
  static propTypes = {
    type: PropTypes.oneOf([
      'x-large',
      'large',
      'extra-bold',
      'semi-bold',
      'medium',
      'regular',
      'small',
      'heading',
      'subheading',
      'body',
      'form-label',
      'caption',
      'disclaimer',
      'form-field-question',
      'header',
      'display',
      'accent',
      'subheader',
      'subheader-secondary',
      'body-alt',
      'small-alt',
      'accent-section-title'
    ]),
    main: PropTypes.bool,
    priority: PropTypes.oneOf([1, 2, 3, 4, 5])
  }

  static defaultProps = {
    type: 'body',
    main: false,
    priority: 1
  }

  render() {
    const {type, className, main, priority, ...props} = this.props,
      classes = [styles[type], className],
      T = `h${priority}`

    return main ?
      <T className={classes.join(' ')} {...props}/>
      :
      <p className={classes.join(' ')} {...props}/>
  }
}

export {Text}
